import { createRoot } from 'react-dom/client'
import { inject } from '@vercel/analytics'
import App from './App'
import { initAnalytics } from './lib/analytics'
import './index.css'
import 'leaflet/dist/leaflet.css'

// Vercel Analytics (працює одразу після деплою на Vercel)
inject();

// GA4 + Meta Pixel — вмикаються, коли задані VITE_GA4_ID / VITE_META_PIXEL_ID
initAnalytics();

createRoot(document.getElementById("root")!).render(<App />);
